<template>
    <div>

      <Basicform
        ref="zytk"
        :title="$tx('hyyt.hyyt.transferLibrary','转议题库')"
        :module-code="moduleInfo.moduleCode"
        :win-width="moduleInfo.winWidth"
        :win-height="moduleInfo.winHeight"
        :append-to-body="true"
        :toolbar-btns="busiformBtns"
        :on-basic-form-opened="onBasicFormOpened"
        :on-basic-form-submited="onBasicFormSubmited"
        :on-basic-form-before-submit="onBasicFormBeforeSubmit"
      >
        <template #default="slotProps">
          <busi-form ref="busiForm" :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="moduleInfo" />
        </template>
      </Basicform>
    </div>
  </template>

<script>
export default {
    components: {

    },
    props: {
        vo: { type: Object, default: function() { return {} } }
    },
    data() {
        return {
            moduleInfo: {
                'formTemplate': 'dcontent/busiformurl?vwtype=W&url=/hygl/ytRecord/form.html.html',
                'winWidth': 1200,
                'delUrl': '/hygl/ytRecord/delete',
                'addNewUrl': '/hygl/ytRecord/addNew',
                'insertUrl': '/hygl/ytRecord/insert',
                'moduleCode': 'ytRecord',
                'winHeight': 600,
                'updateUrl': '/hygl/ytRecord/update',
                'listDataUrl': '/hygl/ytRecord/listdata',
                'getByIdUrl': '/hygl/ytRecord/getById'
            },
            busiformBtns: [],
            dialogVisible: false,
            xzdbytShow: false,
            selectDbrwList: [],
            dbrwObj: {},
            dbtableShow: true,
            nowRow: {},
            hyytShow: false,
            dbrwShow: true,
            dbsxObj: {},
            nowTime: this.$moment(new Date()).format('YYYY-MM-DD HH:mm'),
            dbModeOne: null,
            dbModeLast: null

        }
    },
    computed: {

    },
    watch: {

    },
    created() {
        this.$bus.on('btnConvertToHyytClick', this.btnConvertToHyytClick)
    },
    beforeDestroy() {
        this.$bus.off('btnConvertToHyytClick', this.btnConvertToHyytClick)
    },
    mounted() {

    },
    methods: {

        onBasicFormOpened: function($scope, vo) {
            // vo.passenger.attachments = this.$vnode.context.attachments
            const attachList = []
            // if (this.$vnode.context.bodyfile.fileName.substring(this.$vnode.context.bodyfile.fileName.lastIndexOf('.')).toLowerCase() === '.pdf') {
            //     attachList.push(this.$vnode.context.bodyfile)
            // }
            this.$vnode.context.attachments.forEach(attach => {
                attach.fileType = 'ATTACH'
                attachList.push(attach)
                // if (attach.fileType !== 'BODY' && attach.id !== undefined) {
                //     attachList.push(attach)
                // }
            })
            vo.passenger.attachments = attachList
            console.log($scope, vo, this, attachList, 'hyyt form opened')
            vo.subject = this.vo.flSubject
            vo.status = 0
            //   vo.isSet = 0
            vo.creatDate = this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
            //   vo.overDate = this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
        },
        onBasicFormBeforeSubmit: function($scope, vo, defer) {
            debugger
            if (vo.passenger.attachments && vo.passenger.attachments.length > 0) {
                vo.passenger.attachments.forEach(item => { item.fileType = 'ATTACH' })

                // vo.passenger.attachments = vo.passenger.attachments.filter(attachment => {
                //     return vo.passenger.selectFileIds.includes(attachment.id)
                // })
            }
            console.log($scope, this, vo, defer, 4444)
            defer.resolve(true)
        },
        // 转督办任务
        btnConvertToHyytClick() {
            this.moduleInfo.formTemplate = `#/dcontent/vuebusiform/W/hygl.ytRecord.form.vue?sysCode=${this.vo.orgCode}_ecyhygl`
            this.$options.components['BusiForm'] = this.$loadComponent(this.moduleInfo.formTemplate)
            this.busiformBtns = [
                {
                    id: 'btn_close',
                    btnName: '关 闭',
                    btnIcon: 'close',
                    btnClick: 'closeDialog',
                    btnPermission: '',
                    btnType: '',
                    btnI18nCode: 'close'
                },
                {
                    id: 'btn_save',
                    btnName: '保 存',
                    btnIcon: 'check',
                    btnClick: 'submitBusiform',
                    btnPermission: 'saveObject',
                    btnType: 'primary',
                    btnI18nCode: 'save'
                }
            ]
            this.$nextTick(() => {
                this.$bus.emit('openBusiform', this.moduleInfo, null, 1)
            })
            // this.xzdbytShow = true

            // this.$http({
            //     method: 'post',
            //     url: '/dbgl/task/addNew'
            // }).then(res => {
            //     if (res.code === 'success') {
            //         this.dbrwObj = res.body.vo
            //         this.dbrwObj.creatDate = this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
            //         this.dbrwObj.creator = this.vo.flCreator
            //         this.dbrwObj.creatorId = this.vo.creatorId
            //     } else {
            //         this.$message.error(res.message)
            //     }
            // })
        }

    }
}
</script>

  <style scoped lang="scss">
      // /deep/ .el-table .cell.el-tooltip{
      //     min-width: auto;
      // }
      /deep/.el-checkbox:last-of-type {
          margin-right: 25px !important;
      }
       /deep/.el-table td{
              border-bottom: none;
          }
  .eltable{
              border: 1px solid #EBEEF5;
           border-bottom: none;
           /deep/.el-table__body{
               width: 100%!important;
           }
      }
  /deep/.el-table--enable-row-transition .el-table__body td.el-table__cell{
        border: none;
        border-bottom: none !important;
      }
  </style>
